export default function CardOne({ item}) {


    let weblink = item.web !== "" ? (
        <a href={item.web} target="_blank" rel="noopener noreferrer" aria-label={item.titulo}>Ver proyecto online</a>
    ) : null;

    let gitlink = item.git !== "" ? (
        <a href={item.git} target="_blank" rel="noopener noreferrer" aria-label={item.titulo}>Ver proyecto en GitHub</a>
    ) : null;

    const handleScroll = (id) => {
        if (!id) return; // Si no hay id, salir
      
        setTimeout(() => {  // Pequeño delay para asegurar que el DOM está cargado
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ block: "start" });
          } else {
            console.warn(`Elemento con id "${id}" no encontrado.`);
          }
        }, 100);
      };


    return (
        <div className="card1 item">
            <div className="img-content">
                <img src={item.imagen} alt="experience image" loading="lazy" />
            </div>
            <div className="card1-content">
                <div>
                    <h3 className="card1-title">{item.titulo}</h3>
                    <p className="card1-description">{item.descripcion}</p>
                    <p className="card1-tecnologies"><b>Tecnologías: </b>{item.tecnologias}</p>

                </div>
                <div className="botonera">
                    {weblink} {gitlink}
                    <button className="button-big" onClick={() => handleScroll(item.ref)}>Ver en detalle</button>
                    {/* <a className="button-big" href={item.ref}>Ver en detalle</a> */}
                </div>
            </div>
        </div>
    );
}